<div *ngIf="isBusy" class="spinner-overlay">
  <div class="spinner-wrapper">
    <img src="../assets/hires-logo.png" class="spinner spin-breathe" />
  </div>
</div>
<app-splash *ngIf="showSplash" (done)="showSplash = false" @fadeInOut></app-splash>
<header class="app-header" *ngIf="!showSplash" @fadeInOut>
  <div class="header-left">
    <a routerLink="/events">
      <img src="assets/hires-logo.png" alt="Logo" class="logo" (click)="navigate('/events')" />
    </a>
  </div>

  <div class="header-right" (clickOutside)="closeMenu()">
    <div
      *ngIf="isAuthenticated"
      class="user-avatar"
      (click)="toggleMenu($event)">
      {{ userInitials }}
    </div>

    <div class="avatar-menu" *ngIf="menuOpen">
      <button *ngIf="hasPlayerAdmin" (click)="navigate('/admin/players')" >Manage Players</button>
      <button (click)="logout()">Logout</button>
    </div>
  </div>
</header>

<main class="app-content" [class.visible]="!showSplash">
  <div *ngIf="!showSplash" @fadeInOut class="app-container">
    
    <!-- Your main app content -->
    <router-outlet />
   </div>
</main>